export const START_ONBOARDING = 'START_ONBOARDING';
export const UPDATE_ONBOARDING = 'UPDATE_ONBOARDING';
export const COMPLETE_ONBOARDING = 'COMPLETE_ONBOARDING';
